import { apis } from "../index";
import { AxiosPromise, AxiosRequestConfig } from "axios";

const BASE_URL = "https://xxl6-bbr3-kxzs.m2.xano.io/api";

const CUSTOMER_REGISTRATION_API_URLS = {
  GET_Customer_PHONE_NUMBER_DETAILS_VIA_SEARCH: `${BASE_URL}:NcXLAC78:UAT/searchContactviaPhone`,
  POST_CUSTOMER_REGISTRATION_Step1: `${BASE_URL}:NcXLAC78/customers-step-1`,
  POST_CUSTOMER_REGISTRATION_Step1VerifyOTP: `${BASE_URL}:NcXLAC78/customers-verify-otp`,
  POST_CUSTOMER_REGISTRATION_Step2: `${BASE_URL}:NcXLAC78/customers-step-2`,
  POST_PAN_VERIFICATION_STEP_2_0: `${BASE_URL}:NcXLAC78/customers-step-2_0`,
  POST_CUSTOMER_REGISTRATION_Step3: `${BASE_URL}:NcXLAC78/customers-step-3-without-verification`,
  POST_CUSTOMER_REGISTRATION_Step3VerifyOTP: `${BASE_URL}:NcXLAC78/customers-verify-aadhar-otp`,
  POST_CUSTOMER_REGISTRATION_Step4: `${BASE_URL}:NcXLAC78/customers-step-4`,
  POST_PAN_VERIFICATION_STEP_FALLBACK: `${BASE_URL}:NcXLAC78/customers-step-2_fallback`,
  POST_AADHAAR_VERIFICATION_STEP3_FALLBACK: `${BASE_URL}:NcXLAC78/customers-step-3_fallback`,
  PUT_UPDATE_CUSTOMER_DETAILS: `${BASE_URL}:NcXLAC78/customers`,
} as const;

// Customer Registration Step 1 API
export type PostCustomerRegistrationStep1RequestType = Partial<{
  email: string;
  number: string;
  passport_no: string;
  contacts_id: string | number;
  headers: { Authorization: string };
}>;
export type PostCustomerRegistrationStep1ResponseType = {
  id: string;
};
export const postCustomerRegistrationStep1 = (
  payload: AxiosRequestConfig<PostCustomerRegistrationStep1RequestType>,
): AxiosPromise<PostCustomerRegistrationStep1ResponseType> =>
  apis.post(
    CUSTOMER_REGISTRATION_API_URLS.POST_CUSTOMER_REGISTRATION_Step1,
    payload,
  );

// Customer Registration Step 1 verify OTP
export type PostCustomerRegistrationStep1VerifyOTPRequestType = Partial<{
  customers_id: string | number;
  otp: string;
  type: string;
  headers: { Authorization: string };
}>;
export type PostCustomerRegistrationStep1VerifyOTPResponseType = Partial<{}>;
export const postCustomerRegistrationStep1VerifyOTP = (
  payload: AxiosRequestConfig<PostCustomerRegistrationStep1VerifyOTPRequestType>,
): AxiosPromise<PostCustomerRegistrationStep1VerifyOTPResponseType> =>
  apis.post(
    CUSTOMER_REGISTRATION_API_URLS.POST_CUSTOMER_REGISTRATION_Step1VerifyOTP,
    payload,
  );

// Customer Registration Step 2 API
export type PostCustomerRegistrationStep2RequestType = Partial<{
  customers_id: string | number;
  pan_no: string;
  pan_card: string;
  headers: { Authorization: string };
}>;
export type PostCustomerRegistrationStep2ResponseType = Partial<{}>;
export const postCustomerRegistrationStep2 = (
  payload: AxiosRequestConfig<PostCustomerRegistrationStep2RequestType>,
): AxiosPromise<PostCustomerRegistrationStep2ResponseType> =>
  apis.post(
    CUSTOMER_REGISTRATION_API_URLS.POST_CUSTOMER_REGISTRATION_Step2,
    payload,
  );

export const POSTPanVerify = (
  payload: AxiosRequestConfig<PostCustomerRegistrationStep2RequestType>,
): AxiosPromise<PostCustomerRegistrationStep2ResponseType> =>
  apis.post(
    CUSTOMER_REGISTRATION_API_URLS.POST_PAN_VERIFICATION_STEP_2_0,
    payload,
  );

// Customer Registration Step 3 API
export type PostCustomerRegistrationStep3RequestType = Partial<{
  customers_id: string | number;
  aadhar_number: string;
  aadhar_front: string;
  aadhar_back: string;
  headers: { Authorization: string };
}>;

export type PostCustomerRegistrationStep3ResponseType = {
  data: {
    requestId: string;
  };
};

export const postCustomerRegistrationStep3 = (
  payload: AxiosRequestConfig<PostCustomerRegistrationStep3RequestType>,
): AxiosPromise<PostCustomerRegistrationStep3ResponseType> =>
  apis.post(
    CUSTOMER_REGISTRATION_API_URLS.POST_CUSTOMER_REGISTRATION_Step3,
    payload,
  );

// Customer Registration Step 3 verify OTP
export type PostCustomerRegistrationStep3VerifyOTPRequestType = Partial<{
  customers_id: string | number;
  otp: string;
  request_id: string;
  headers: { Authorization: string };
}>;

export type PostCustomerRegistrationStep3VerifyOTPResponseType = Partial<{}>;
export const postCustomerRegistrationStep3VerifyOTP = (
  payload: AxiosRequestConfig<PostCustomerRegistrationStep3VerifyOTPRequestType>,
): AxiosPromise<PostCustomerRegistrationStep3VerifyOTPResponseType> =>
  apis.post(
    CUSTOMER_REGISTRATION_API_URLS.POST_CUSTOMER_REGISTRATION_Step3VerifyOTP,
    payload,
  );

// Customer Registration Step 4 API

export type PostCustomerRegistrationStep4RequestType = Partial<{
  customers_id: string | number;
  bank_account_no: string;
  bank_name: string;
  ifsc_code: string;
  cancel_cheque: string;
  nameMismatch: boolean;
  headers: { Authorization: string };
}>;

export type PostCustomerRegistrationStep4ResponseType = {
  id: string;
  status: string;
};

export const postCustomerRegistrationStep4 = (
  payload: AxiosRequestConfig<PostCustomerRegistrationStep4RequestType>,
): AxiosPromise<PostCustomerRegistrationStep4ResponseType> =>
  apis.post(
    CUSTOMER_REGISTRATION_API_URLS.POST_CUSTOMER_REGISTRATION_Step4,
    payload,
  );

export type PostCustomerRegistrationStep2FallbackReqType = Partial<{
  customers_id: string | number;
  pan_no: string;
  name: string;
  pan_card: string;
  headers: { Authorization: string };
}>;

export type PostCustomerRegistrationStep2FallbackResType = Partial<{}>;

export const POSTPanVerifyFallback = (
  payload: AxiosRequestConfig<PostCustomerRegistrationStep2FallbackReqType>,
): AxiosPromise<PostCustomerRegistrationStep2FallbackResType> =>
  apis.post(
    CUSTOMER_REGISTRATION_API_URLS.POST_PAN_VERIFICATION_STEP_FALLBACK,
    payload,
  );

export type PostCustomerRegistrationStep3FallbackReqType = Partial<{
  customers_id: string | number;
  aadhar_number: string;
  name: string;
  date: string;
  address: string;
  aadhar_front_img: string;
  aadhar_back_img: string;
  headers: { Authorization: string };
}>;

export type PostCustomerRegistrationStep3FallbackResType = Partial<{}>;

export const POSTAadhaarVerifyFallback = (
  payload: AxiosRequestConfig<PostCustomerRegistrationStep3FallbackReqType>,
): AxiosPromise<PostCustomerRegistrationStep3FallbackResType> =>
  apis.post(
    CUSTOMER_REGISTRATION_API_URLS.POST_AADHAAR_VERIFICATION_STEP3_FALLBACK,
    payload,
  );

// get conatct number based user customer details
export type GetCustomerPhoneNumberRequestType = Partial<{
  headers: { Authorization: string };
  q: string;
}>;

export type GetCustomerResponseType = {
  id: Number;
  contactName: string;
  contactNumber: string;
  contactEmail: string;
};

export const getCustomerPhoneNumberDetails = (
  payload: AxiosRequestConfig<GetCustomerPhoneNumberRequestType>,
): AxiosPromise<GetCustomerResponseType> =>
  apis.get(
    CUSTOMER_REGISTRATION_API_URLS.GET_Customer_PHONE_NUMBER_DETAILS_VIA_SEARCH,
    payload,
  );

//
export type PutUpdateCustomerDetailsReqType = Partial<{
  headers: {
    Authorization: string;
  };
  customers_id: string | number;
  phone_number: string;
  name: string;
  email: string;
  address: string;
  notes: string;
}>;

export type PutUpdateCustomerDetailsResponseType = Partial<{}>;

export const PutUpdateCustomerDetails = (
  payload: AxiosRequestConfig<PutUpdateCustomerDetailsReqType>,
): AxiosPromise<PutUpdateCustomerDetailsResponseType> => {
  const customersId = payload?.data?.customers_id;
  const url = `${CUSTOMER_REGISTRATION_API_URLS.PUT_UPDATE_CUSTOMER_DETAILS}/${customersId}`;
  return apis.put(url, payload);
};
